import React from 'react'
import Errors from '../errors'

const ErrorsDa = () => {
    return <Errors languageCode="da" />
}

export default ErrorsDa
